module.exports = __webpack_public_path__ + "static/img/1-1Z5291K101O5.74a07b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5291K101O5.jpg
// module id = uDV/
// module chunks = 0